import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { Media } from '../../../../../theme/Media.js';
import { Button } from '../../../../Controls/Button/index.js';
import Icons from '../../../../Elements/Icons/index.js';
import { Select } from '../../../../Form/Select/index.js';
import { PageInfo } from '../PageInfo/index.js';
import { TableInfo } from '../TableInfo/index.js';
import { paginationPresetDefault, paginationPresetReduced } from './constants.js';
import { PageInfoWrapper, Wrapper } from './styled.js';
export const TablePagination = memo(function TablePagination({ className, info, pagination, isLoading, dataTestId, }) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const selectedPerPage = useMemo(() => ({ label: String(pagination.perPage), value: pagination.perPage }), [pagination.perPage]);
    const isReducedPaginationPreset = useMemo(() => !!paginationPresetReduced.find((option) => option.value === pagination.perPage), [pagination.perPage]);
    const handleSetPerPage = useCallbackRef((option) => {
        if (option) {
            pagination.setPerPage(option.value);
            pagination.setPage(0);
        }
    });
    const nextPage = useCallbackRef(() => {
        pagination.setPage((prev) => prev + 1);
    });
    const prevPage = useCallbackRef(() => {
        pagination.setPage((prev) => prev - 1);
    });
    if (!isLoading && info.total <= pagination.perPage) {
        return _jsx(TableInfo, { total: info.total, isLoading: isLoading });
    }
    return (_jsxs(Wrapper, { className: className, "data-testid": dataTestId, children: [!isMobile && (_jsx("div", { "data-testid": 'per-page-dropdown', children: _jsx(Select, { options: isReducedPaginationPreset ? paginationPresetReduced : paginationPresetDefault, value: selectedPerPage, onChange: handleSetPerPage, menuPlacement: 'auto', "data-testid": 'select-op' }) })), _jsx(PageInfoWrapper, { children: _jsx(PageInfo, { dataTestId: 'from-to-total-pagination', ...info, isLoading: isLoading }) }), _jsx(Button, { secondary: true, iconOnly: true, onClick: prevPage, disabled: pagination.page === 0, "data-testid": 'backward-button', children: _jsx(Icons.Arrow, { align: 'left' }) }), _jsx(Button, { secondary: true, iconOnly: true, onClick: nextPage, disabled: info.total === 0 || pagination.page === Math.ceil(info.total / pagination.perPage) - 1, "data-testid": 'forward-button', children: _jsx(Icons.Arrow, { align: 'right' }) })] }));
});
export { usePageInfo } from './usePageInfo.js';
export { usePagination } from './usePagination.js';
